import {
    ADD_MULTIBET_SELECTION,
    REMOVE_MULTIBET_SELECTION,
    SELECT_RACING_BET_TYPE,
    TOGGLE_BETTING_TYPE_BUTTON_DISPLAYED,
    TOOGLE_BOX_BETS
} from '../constants/actionTypes';
import {EXACTA, PLACE, SHOW, TRIFECTA, WIN} from '../constants/identifiers';

export default (state, action) => {
    let newSelectedMultiBetList;
    switch (action.type) {
        case SELECT_RACING_BET_TYPE:
            return {
                ...state,
                selectedRacingBetType: action.betType
            };
        case TOGGLE_BETTING_TYPE_BUTTON_DISPLAYED:
            let newSelectedRacingBetType = state.selectedRacingBetType;
            switch (state.selectedRacingBetType) {
                case WIN:
                case PLACE:
                case SHOW:
                    newSelectedRacingBetType = EXACTA;
                    break;
                case EXACTA:
                case TRIFECTA:
                    newSelectedRacingBetType = WIN;
                    break;
                default:

            }

            return {
                ...state,
                selectedRacingBetType: newSelectedRacingBetType,
                isSimpleBetsSelected: !state.isSimpleBetsSelected
            };

        case ADD_MULTIBET_SELECTION:
            newSelectedMultiBetList = state.selectedEventMultiBetList.slice();
            newSelectedMultiBetList.push(action.racerNum);

            return {
                ...state,
                selectedEventMultiBetList: newSelectedMultiBetList
            };
        case REMOVE_MULTIBET_SELECTION:
            newSelectedMultiBetList = state.selectedEventMultiBetList.slice();
            newSelectedMultiBetList.splice(newSelectedMultiBetList.indexOf(action.racerNum), 1);

            return {
                ...state,
                selectedEventMultiBetList: newSelectedMultiBetList
            };
        case TOOGLE_BOX_BETS:
            return {
                ...state,
                isBoxBetsButtonToggled: !state.isBoxBetsButtonToggled
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/racing/reducers/raceCardReducer.js